<template>
    <div
        :style="{
            color: player.headingColor,
        }"
        class="cursor-pointer relative group"
    >
        <div class="h-full w-full flex p-3 items-center space-x-2">
            <ChevronDownIcon
                :class="[isOpen ? 'rotate-180' : 'rotate-0']"
                class="transition-transform flex-shrink-0 h-5 w-5"
            />

            <div class="flex-grow">
                <cUtilsEdit @edit="goToFileField(section.header.id, 'fileName')">
                    <p class="text-sm font-medium">
                        {{ section.header.name }}
                    </p>
                </cUtilsEdit>
            </div>
            <p class="text-sm opacity-80">{{ nOfWatched }}/{{ nOfFiles }}</p>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { ChevronDownIcon } from "@easy/ui/icons";
import { usePlayerGoTo } from "@/views/tools/player/utils/usePlayerGoTo";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";

export default {
    name: "SidebarHeader",
    props: {
        section: Object,
        isOpen: Boolean,
    },
    setup() {
        const { goToFileField } = usePlayerGoTo();
        return { goToFileField };
    },
    components: {
        ChevronDownIcon,
        cUtilsEdit,
    },
    computed: {
        ...mapState("shared/view", ["preview"]),
        ...mapState("player/view", ["player", "watched"]),
        notDeletedFiles() {
            return this.section.files.filter((file) => !file._deleted && !file.hide);
        },
        releasedFiles() {
            if (this.preview) {
                return this.notDeletedFiles;
            }
            const now = new Date();
            return this.notDeletedFiles.filter(
                (file) =>
                    !(file.releaseAt && new Date(file.releaseAt) > now && !file.showBeforeRelease)
            );
        },
        nOfWatched() {
            return this.releasedFiles.filter((file) => this.watched.includes(file.id)).length;
        },
        nOfFiles() {
            return this.releasedFiles.length;
        },
    },
};
</script>
